const state = {
    /** 전체 허브 리스트 */
    hubs: [],
    /** 관제대상 허브 */
    subscribeHubInfo: [],
    /** 임시 선택 허브 */
    tmpSubscribeHubInfo: [],
    /** GNB 비활성 여부 */
    isHubSelectorDisabled: false,
    /** 관제허브의 좌표 */
    coordinate: {
        longitude: null,
        latitude: null,
    },
};
export default state;
